import { render } from "./HeroiconsSolidDatabase.vue?vue&type=template&id=e28338fc"
const script = {}

import exportComponent from "/home/harlan/sites/kintell-env/api/packages/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidDatabase.vue"]])

export default __exports__